import type { ComponentType } from "react";
import LoadingBackdropOverlayProvider from "./LoadingBackdropOverlayProvider";
import LoadingBackdropOverlay from "./LoadingBackdropOverlay";
import type { LoadingBackdropOverlayProps } from "./types";

export const withLoadingBackdropOverlay = <TProps extends object>(
    Component: ComponentType<TProps>,
    overlayDefaultProps = {} as LoadingBackdropOverlayProps
) =>
    (props: TProps) => (
        <LoadingBackdropOverlayProvider>
            <Component
                {...props}
            />
            <LoadingBackdropOverlay
                {...overlayDefaultProps}
            />
        </LoadingBackdropOverlayProvider>
    );

export default withLoadingBackdropOverlay;
